var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-imgup"},[(_vm.src != '')?_c('img',{staticClass:"img",attrs:{"src":_vm.src},on:{"click":_vm.onClick}}):_c('img',{staticClass:"img",attrs:{"src":_vm.$config.imgUrlCom + 'df_img.jpg'}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ed96cd7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myImgshow.vue
// module id = null
// module chunks = 